import { render, staticRenderFns } from "./bind-email.vue?vue&type=template&id=450f7de1&scoped=true&"
import script from "./bind-email.vue?vue&type=script&lang=js&"
export * from "./bind-email.vue?vue&type=script&lang=js&"
import style0 from "./bind-email.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bind-email.vue?vue&type=style&index=1&id=450f7de1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f7de1",
  null
  
)

export default component.exports